import React from 'react';
import PropTypes from 'prop-types';
import CustomStep from 'workOrderComponents/close/CustomStep';
import SignalLevelsPanel from "./SignalLevelsPanel";
import { signalLevelsFormConfig } from "../../constants/signalLevelsFormConfig";
import { signalLevelFieldValidator } from "../../utils/signalLevelFieldValidator";

class SignalLevelsCloseStep extends React.Component {
    constructor(props) {
        super(props);

        this.handleValueValidation = this
            .handleValueValidation
            .bind(this);
        this.handleCheckStateChange = this
            .handleCheckStateChange
            .bind(this);
        this.handleTextValueChange = this
            .handleTextValueChange
            .bind(this);
    }

    handleValueValidation(value, action) {
        const sections = signalLevelsFormConfig.sections;

        return signalLevelFieldValidator(sections, value, action);
    }

    handleCheckStateChange(e, value, action) {
        const { workOrderActions, orderId, orderCloseDetails } = this.props;
        const errors = orderCloseDetails.getIn(['signalLevelsDetails', 'errors']);

        workOrderActions.setFstSignalValue({
            value: value,
            action: action,
            errors: errors,
            errorLocation: "signalLevelsDetails",
            storeLocation: "signalLevel"
        }, orderId);
    }

    handleTextValueChange(value, action) {
        const { workOrderActions, orderId, techId, orderCloseDetails } = this.props;
        const errors = this.handleValueValidation(value, action);

        workOrderActions.setFstSignalValue({
            value: value,
            action: action,
            errors: errors.errors,
            errorMessage: errors.errorMessage,
            errorLocation: "signalLevelsDetails",
            storeLocation: "signalLevel"
        }, orderId);

        // because we want the initial state of the "signalLevel" tree to be null or undefined
        // we don't want to set the tech id in the component will mount call.
        const savedTechId = orderCloseDetails.getIn([
            'closeOrderRequest',
            'signalLevel',
            'techId'
        ]);

        // this makes sure we only run this once when they change the text value
        if (!savedTechId) {
            workOrderActions.setTechIdSignalLevels(techId, orderId);
        }
    }

    getDropdownOptionsList() {
        return [
            {
                value: true,
                label: 'Pass'
            }, {
                value: false,
                label: 'Fail'
            }];
    }

    render() {
        const { orderCloseDetails, stepConfig, orderId, index, workOrderActions } = this.props;
        const stepValidation = orderCloseDetails.getIn(['stepValidation']);
        const activeStep = orderCloseDetails.get('currentStep');
        const dropdownOptions = this.getDropdownOptionsList();
        const sections = signalLevelsFormConfig.sections;
        const signalLevelsDetails = orderCloseDetails.getIn(['signalLevelsDetails']);
        const signalLevelsStore = orderCloseDetails.getIn(['closeOrderRequest', 'signalLevel']);
        const channels = orderCloseDetails.getIn(['channelsDetails']);

        return (
            <CustomStep
                onStepClick={workOrderActions.setCloseStep}
                label={`Signal Levels`}
                stepConfig={stepConfig}
                stepConfigKey="fstSignalStepConfig"
                index={index}
                activeStep={activeStep}
                orderId={orderId}
                stepValidation={stepValidation}
                stepKey="signalLevels">
                <SignalLevelsPanel
                    workOrderActions={workOrderActions}
                    orderCloseDetails={orderCloseDetails}
                    orderId={orderId}
                    handleTextValueChange={this.handleTextValueChange}
                    handleCheckStateChange={this.handleCheckStateChange}
                    dropdownOptions={dropdownOptions}
                    sections={sections}
                    signalLevelsStore={signalLevelsStore}
                    signalLevelsDetails={signalLevelsDetails}
                    channels={channels}
                />
            </CustomStep>
        )
    }
}

SignalLevelsCloseStep.propTypes = {
    workOrderActions: PropTypes.object,
    techId: PropTypes.string,
    index: PropTypes.number,
    orderCloseDetails: PropTypes.object,
    orderId: PropTypes.string,
    stepConfig: PropTypes.object,
};

export default SignalLevelsCloseStep;



// WEBPACK FOOTER //
// ./src/components/signal-levels/SignalLevelsCloseStep.js